exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu {\n    background: white;\n    border: 1px solid green;\n    border-radius: 7px;\n    position: absolute;\n    min-width: 100px;\n    width: 250px;\n    height: 24px;\n    right: 10px;\n    z-index: 300;\n}\n", ""]);

// exports
